import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { ScrollView, View } from 'react-native';
import { CardEditorForm } from '../dashboard/editor/CardEditorForm';
import { EditorFooter } from '../dashboard/editor/EditorFooter';
import { BiCardEditor } from '../dashboard/editor/functions/useBiCardEditor';

/** How wide the configuration column is beside the card on desktop. */
export const kBiCardConfigWidth = 400;

/**
 * The card's configuration beside it on desktop, a card of its own in the
 * page's column: the editor and the style options, previewed live in the
 * card column, then cancel and save pinned at its bottom.
 */
export const CardConfigPane = memo(
  ({
    editor,
    palette,
    onCancel,
  }: {
    editor: BiCardEditor;
    palette: BiPalette;
    onCancel: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        style={{
          width: rpx(kBiCardConfigWidth),
          // Level with the card's top, and clear of the page's bottom edge.
          marginVertical: rpx(16),
          backgroundColor: aiColors.card,
          borderRadius: rpx(14),
          borderWidth: 1,
          borderColor: aiColors.border,
          overflow: 'hidden',
        }}
      >
        <View style={{ paddingHorizontal: rpx(24), paddingTop: rpx(18) }}>
          <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
            配置
          </Typography.Text>
        </View>
        <ScrollView
          style={{ flex: 1 }}
          contentContainerStyle={{ padding: rpx(24) }}
          keyboardShouldPersistTaps="handled"
        >
          <CardEditorForm
            editor={editor}
            palette={palette}
            withPreview={false}
          />
        </ScrollView>
        <EditorFooter
          error={editor.error}
          saveTitle="保存"
          busy={editor.busy}
          canSave={editor.canSave}
          onCancel={onCancel}
          onSave={() => void editor.save()}
        />
      </View>
    );
  },
);
